import React from "react";
import Modal from "react-modal";
import KonfhubContainer from "../Container";
import Loading from "../../../components/Loading";

const LoadingModal = ({
	isOpen,
	onClose,
	width,
	height,
	overflow,
	className,
	styles,
	description
}) => {
	const customStyles = {
		// Style for the Modal
		content: {
			top: "50%",
			left: "50%",
			right: "auto",
			bottom: "auto",
			marginRight: "-50%",
			transform: "translate(-50%, -50%)",
			padding: "0px",
			maxWidth: "90%",
			maxHeight: "calc(100% - 75px)",
			width: width ? width : "auto",
			height: height ? height : "auto",
			overflow: overflow ? overflow : "hidden",
			overflowX: "hidden"
		},
		overlay: {
			background: "rgba(0,0,0,0.75)",
			height: "100%",
			zIndex: "100"
		}
	};
	return (
		<>
			<Modal
				ariaHideApp={false}
				isOpen={isOpen}
				shouldCloseOnEsc={false}
				shouldCloseOnOverlayClick={false}
				onRequestClose={() => {
					if (onClose) onClose();
				}}
				className={className}
				style={styles ? styles : customStyles}
			>
				<KonfhubContainer>
					<div className="w-100 text-center p-5">
						<Loading />
					</div>
					<p className="description-box">{description}</p>
				</KonfhubContainer>
			</Modal>

			<style>{`
				body.modal-open {
					overflow: hidden;
				}
				.description-box {
                    font-size: 12px;
                    color: #3e4676;
                    text-align: center;
                    margin-top: 10px;
                    margin-bottom: 10px;
                }
			`}</style>
		</>
	);
};

export default LoadingModal;
